import { policies } from '~domain/i18n/french/policies';
import { BaseTranslationKeys } from '../english';
import { carriers } from './carriers';

export const french: BaseTranslationKeys = {
  common: {
    amfLicensed:
      'Assurance YouSet est un cabinet de courtage en assurance de dommages inscrit auprès de l’AMF. Nous comparons pour toi les prix de plusieurs assureurs comme Intact, Economical, L’Unique et autres. La liste complète est disponible sur notre site web.',
    copyright: 'YOUSET INSURANCE TECHNOLOGIES {{0}} TOUS DROITS RÉSERVÉS',
  },
  productTypes: {
    home: 'Habitation',
    car: 'Auto',
  },
  carriers,
  policies,
};
